// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Sfbk","col":"styles_col__OZH10","actions":"styles_actions__PsVk4","conflict":"styles_conflict__1Rafd"};